<script lang="ts">
  // Forecast AI targets vs what was done, per XSS type: a bar per type with the target marked.
  import { XSS_COLORS, type ReportContext } from '../context'
  import Icon from './Icon.svelte'

  export let ctx: ReportContext
  export let compact = false

  $: x = ctx.data.xfai!
  $: rows = ([
    { key: 'xlss', label: 'Low' },
    { key: 'xhss', label: 'High' },
    { key: 'xpss', label: 'Peak' },
  ] as const).map((r) => ({
    ...r,
    color: XSS_COLORS[r.key],
    target: x.target[r.key],
    done: x.completed[r.key],
    compliance: x.compliance[r.key],
  }))
  $: scale = Math.max(1, ...rows.map((r) => Math.max(r.target, r.done))) * 1.08
  const icon = { Good: 'check', Warn: 'alert', Alert: 'x' } as const
</script>

<div class="xr-targets" class:xr-compact={compact}>
  {#each rows as row}
    <div class="xr-row">
      <div class="xr-head">
        <span class="xr-label"><span class="xr-dot" style="background: {row.color};" />{row.label}</span>
        <span class="xr-nums"><strong>{row.done}</strong><span class="xr-of"> / {row.target}</span></span>
        {#if row.compliance && row.target > 0}
          <span class="xr-mark {row.compliance}"><Icon name={icon[row.compliance]} size={22} stroke={3.2} /></span>
        {/if}
      </div>
      <div class="xr-track">
        <div class="xr-fill" style="width: {(row.done / scale) * 100}%; background: {row.color};" />
        {#if row.target > 0}
          <div class="xr-tick" style="left: {(row.target / scale) * 100}%;" />
        {/if}
      </div>
    </div>
  {/each}
</div>

<style>
  .xr-targets {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
  .xr-compact {
    gap: 16px;
  }
  .xr-head {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .xr-label {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--muted);
    min-width: 110px;
  }
  .xr-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
  .xr-nums {
    margin-left: auto;
    font-size: 26px;
  }
  .xr-nums strong {
    font-weight: 800;
  }
  .xr-of {
    color: var(--muted);
  }
  .xr-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    color: #0b1114;
  }
  .xr-mark.Good { background: var(--good); }
  .xr-mark.Warn { background: #ffcf0c; }
  .xr-mark.Alert { background: var(--bad); color: #fff; }
  .xr-track {
    position: relative;
    margin-top: 10px;
    height: 18px;
    border-radius: 999px;
    background: var(--faint);
  }
  .xr-compact .xr-track {
    height: 14px;
  }
  .xr-fill {
    height: 100%;
    border-radius: 999px;
  }
  .xr-tick {
    position: absolute;
    top: -7px;
    bottom: -7px;
    width: 5px;
    margin-left: -2.5px;
    border-radius: 3px;
    background: currentColor;
  }
</style>
